import logo from '../assets/logo-landscape-png.png';
import mainLogo from '../assets/logo.png';
import backg from '../assets/restaurant_bg.jpg';
import header from '../assets/header-img.jpg';
import spoon from '../assets/spoon.png';
import menu from '../assets/menu.png';

import mrMaphanga from '../assets/mr-maphanga.jpg';
import mrsMaphanga from '../assets/mrs-maphanga.jpg';

import img1 from '../assets/Exterior_Front_View.jpg';
import img2 from '../assets/Terrace_Seating.jpg';
import img3 from '../assets/Entrance_Welcome_Area.jpg';
import img4 from '../assets/Bar_Area_Design.jpg';
import img5 from '../assets/Interior_Main_Dining_Area.jpg';
import img6 from '../assets/Interior_Private_Dining_Room.jpg';
import img7 from '../assets/Exterior_Angle_View.jpg';

// Menu Page

import sushi from '../assets/menu/sushi.png';
import sushi2 from '../assets/menu/sushi2.png';
import salads_and_light_meals from '../assets/menu/salads_and_light_meals.png';
import grills from '../assets/menu/grills.png';
import traditional_and_sea_food from '../assets/menu/traditional_and_sea_food.png';
import More_from_the_Kitchen from '../assets/menu/More_from_the_Kitchen.png';

// Gallery Page - bevs

import Cocktails from '../assets/menu/Cocktails.png';
import Milkshakes_and_Smoothies from '../assets/menu/Milkshakes_and_Smoothies.png';

import Wine_List1 from '../assets/menu/wine_list (1).png';
import Wine_List2 from '../assets/menu/wine_list (2).png';
import Wine_List3 from '../assets/menu/wine_list (3).png';
import Wine_List4 from '../assets/menu/wine_list (4).png';
import Wine_List5 from '../assets/menu/wine_list (5).png';
import Wine_List6 from '../assets/menu/wine_list (6).png';
import Wine_List7 from '../assets/menu/wine_list (7).png';

// Gallery Page - gallry

import gallery1 from '../assets/slider-img/OurGallery/gallery/gallery (1).jpeg';
import gallery2 from '../assets/slider-img/OurGallery/gallery/gallery (2).jpg';
import gallery3 from '../assets/slider-img/OurGallery/gallery/gallery (3).jpeg';
import gallery4 from '../assets/slider-img/OurGallery/gallery/gallery (4).jpeg';
import gallery5 from '../assets/slider-img/OurGallery/gallery/gallery (5).jpg';
import gallery6 from '../assets/slider-img/OurGallery/gallery/gallery (6).jpg';
import gallery7 from '../assets/slider-img/OurGallery/gallery/gallery (7).jpeg';
import gallery8 from '../assets/slider-img/OurGallery/gallery/gallery (8).jpeg';
import gallery9 from '../assets/slider-img/OurGallery/gallery/gallery (9).jpg';
import gallery10 from '../assets/slider-img/OurGallery/gallery/gallery (10).jpeg';
import gallery11 from '../assets/slider-img/OurGallery/gallery/gallery (11).jpg';
import gallery12 from '../assets/slider-img/OurGallery/gallery/gallery (12).jpg';
import gallery13 from '../assets/slider-img/OurGallery/gallery/gallery (13).jpg';
import gallery14 from '../assets/slider-img/OurGallery/gallery/gallery (14).jpg';
import gallery15 from '../assets/slider-img/OurGallery/gallery/gallery (15).jpg';
import gallery16 from '../assets/slider-img/OurGallery/gallery/gallery (16).jpg';
import gallery17 from '../assets/slider-img/OurGallery/gallery/gallery (17).jpg';
import gallery18 from '../assets/slider-img/OurGallery/gallery/gallery (18).jpg';
import gallery19 from '../assets/slider-img/OurGallery/gallery/gallery (19).jpg';
import gallery20 from '../assets/slider-img/OurGallery/gallery/gallery (20).jpg';

// Gallery Page - meal

import meal1 from '../assets/slider-img/OurGallery/meal/meal (1).jpg';
import meal2 from '../assets/slider-img/OurGallery/meal/meal (2).jpeg';
import meal3 from '../assets/slider-img/OurGallery/meal/meal (3).jpeg';
import meal4 from '../assets/slider-img/OurGallery/meal/meal (4).jpeg';
import meal5 from '../assets/slider-img/OurGallery/meal/meal (5).jpeg';
import meal6 from '../assets/slider-img/OurGallery/meal/meal (6).jpeg';
import meal7 from '../assets/slider-img/OurGallery/meal/meal (7).jpeg';
import meal8 from '../assets/slider-img/OurGallery/meal/meal (8).jpeg';
import meal9 from '../assets/slider-img/OurGallery/meal/meal (9).jpeg';
import meal10 from '../assets/slider-img/OurGallery/meal/meal (10).jpeg';
import meal11 from '../assets/slider-img/OurGallery/meal/meal (11).jpeg';
import meal12 from '../assets/slider-img/OurGallery/meal/meal (12).jpeg';
import meal13 from '../assets/slider-img/OurGallery/meal/meal (13).jpeg';
import meal14 from '../assets/slider-img/OurGallery/meal/meal (14).jpeg';
import meal15 from '../assets/slider-img/OurGallery/meal/meal (15).jpeg';
import meal16 from '../assets/slider-img/OurGallery/meal/meal (16).jpeg';
import meal17 from '../assets/slider-img/OurGallery/meal/meal (17).jpeg';
import meal18 from '../assets/slider-img/OurGallery/meal/meal (18).jpeg';
import meal19 from '../assets/slider-img/OurGallery/meal/meal (19).jpeg';
import meal20 from '../assets/slider-img/OurGallery/meal/meal (20).jpeg';
import meal21 from '../assets/slider-img/OurGallery/meal/meal (21).jpeg';
import meal22 from '../assets/slider-img/OurGallery/meal/meal (22).jpeg';
import meal23 from '../assets/slider-img/OurGallery/meal/meal (23).jpeg';
import meal24 from '../assets/slider-img/OurGallery/meal/meal (24).jpeg';
import meal25 from '../assets/slider-img/OurGallery/meal/meal (25).jpeg';
import meal26 from '../assets/slider-img/OurGallery/meal/meal (26).jpeg';
import meal27 from '../assets/slider-img/OurGallery/meal/meal (27).jpeg';
import meal28 from '../assets/slider-img/OurGallery/meal/meal (28).jpeg';
import meal29 from '../assets/slider-img/OurGallery/meal/meal (29).jpeg';
import meal30 from '../assets/slider-img/OurGallery/meal/meal (30).jpeg';
import meal31 from '../assets/slider-img/OurGallery/meal/meal (31).jpeg';

import meal33 from '../assets/slider-img/OurGallery/meal/meal (33).jpeg';
import meal34 from '../assets/slider-img/OurGallery/meal/meal (34).jpg';
import meal35 from '../assets/slider-img/OurGallery/meal/meal (35).jpg';
import meal36 from '../assets/slider-img/OurGallery/meal/meal (36).jpg';

// eslint-disable-next-line
export default {
  logo,
  mainLogo,
  backg,
  header,
  spoon,
  menu,

  mrMaphanga,
  mrsMaphanga,

  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,

  // Menu Page

  sushi,
  sushi2,

  salads_and_light_meals,
  grills,
  traditional_and_sea_food,
  More_from_the_Kitchen,

  // Gallery Page - bevs

  Cocktails,
  Milkshakes_and_Smoothies,

  Wine_List1,
  Wine_List2,
  Wine_List3,
  Wine_List4,
  Wine_List5,
  Wine_List6,
  Wine_List7,

  // Gallery Page - gallry

  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery15,
  gallery16,
  gallery17,
  gallery18,
  gallery19,
  gallery20,

  // Gallery Page - meal

  meal1,
  meal2,
  meal3,
  meal4,
  meal5,
  meal6,
  meal7,
  meal8,
  meal9,
  meal10,
  meal11,
  meal12,
  meal13,
  meal14,
  meal15,
  meal16,
  meal17,
  meal18,
  meal19,
  meal20,
  meal21,
  meal22,
  meal23,
  meal24,
  meal25,
  meal26,
  meal27,
  meal28,
  meal29,
  meal30,
  meal31,
  meal33,
  meal34,
  meal35,
  meal36,
};
